import React from 'react';

import styles from './styles.module.scss';

// eslint-disable-next-line react/prop-types
export const Title = ({ title }) => (
    <div className={styles.container}>
        <h1>{title}</h1>
    </div>
);
